




import Component, { mixins } from "vue-class-component";
import { TagInfo } from "@scrile/api-provider/dist/api/TagsProvider";
import WithUserTags from "@/mixins/WithUserTags";
import providers from "@/lib/api";
import SelectTagsView from "@/components/SelectTagsView";

@Component({ name: "SelectUserTagsController", components: { SelectTagsView } })
export default class SelectUserTagsController extends mixins(WithUserTags) {
  public tags: TagInfo[] = [];

  public userTags: string[] = [];

  public loading = false;

  public async getData() {
    try {
      this.loading = true;
      await Promise.all([
        providers.TagsProvider.findAll().then(r => (this.tags = r)),
        this.userTagsGetData().then(r => (this.userTags = r)),
      ]);
    } finally {
      this.loading = false;
    }
  }

  public async save(tags: string[], cb: Function) {
    try {
      await this.userTagsUpdateData(tags);
      this.$emit("save", tags);
    } finally {
      cb();
    }
  }

  public created() {
    this.getData();
  }
}
